import { Owner, ProjectDTO } from 'cargo-chief-commons';

export const projectsPageStateKey = 'projects-page';

export interface ProjectsState {
	activeTab: string;
	annualVolume: boolean;
	error: string;
	filters: any[];
	loading: boolean;
	projects: ProjectDTO[];
	sort: any[];
	total: number;
	userId: number;
	usersList: Owner[];
	allTabs: string[];
	userSortAndFilters: any[];
}

export const initialState: ProjectsState = {
	activeTab: 'All Lanes',
	annualVolume: false,
	error: null,
	filters: [],
	loading: true,
	projects: [],
	sort: [],
	total: 0,
	userId: null,
	usersList: [],
	allTabs: ['All Lanes'],
	userSortAndFilters: [],
};
